import jQuery from 'jquery';

(function ($) {
  // alert($( window ).width());
      $(function(){
  
          // $('.selectpicker').selectpicker({
          //     size: 4
          // });

        //   bootstrapSelect.selectpicker('.selectpicker', {
        //     size: 4
        // });




          $('.selectpicker').click(function(){ 
              $(this).toggleClass('open') 
          });
  
  
          $('.show-more').click(function(e){
              e.preventDefault();
              $(this).hide().next().slideToggle();
          });
  
          // Select calculator type
          $(document.body).on("click", '#calculator .buttons a.btn:not(.btn-active)', function(){
              var index = $('#calculator .buttons a.btn').index(this);
  
              $('.btn-calc').removeClass('disabled');
              $('.result-container').hide();
              
              
              $('.calc-area').fadeOut().promise().done(function(){
                  $('.calc-area').eq(index).fadeIn();
              });
              
              // Select relevant button
              $('#calculator .buttons a.btn').removeClass('btn-active');
              $(this).addClass('btn-active');
  
              //$(window).scrollTo($('#scrollToCalc'), {duration: 500});
          });
          
  
          // Reset results when form edited
          $("#calculator .calc-area select, #calculator .calc-area input[type='text']").change(function(){
              $('#calculator .calc-button-area .btn-calc').removeClass('disabled');
              $('.result-container').fadeOut();
          });
  
          // Click 'Calculate' button
          $('#calculator .calc-button-area .btn-calc').click(function(){
  
              
              var index = $('.btn-active').index('#calculator .buttons a.btn');
  
              switch(index){
  
              case 0:
  
                  var recSeconds = $('.calc-area-shutint .rectime option:selected').val();
                  if($('.calc-area-shutint .recunits option:selected').val() == 'm')recSeconds *= 60;
                  if($('.calc-area-shutint .recunits option:selected').val() == 'h')recSeconds *= 3600;
                  if($('.calc-area-shutint .recunits option:selected').val() == 'd')recSeconds *= 86400;
                  
                  var outSeconds = $('.calc-area-shutint .outtime option:selected').val();
                  if($('.calc-area-shutint .outunits option:selected').val() == 'm')outSeconds *= 60;
                  if($('.calc-area-shutint .outunits option:selected').val() == 'h')outSeconds *= 3600;
                  if($('.calc-area-shutint .outunits option:selected').val() == 'd')outSeconds *= 86400;
                  
                  var fps = $('.calc-area-shutint .fps option:selected').val();
                  
                  var interval = fps / recSeconds;
                  var shotspermsec = (interval * outSeconds) / 1000;
                  var shotspersec = interval * outSeconds;
                  var shotspermin = shotspersec * 60;
                  var shotsperhour= shotspermin * 60;
                  var shotsperday = shotsperhour * 24;
                  
  
                  if(recSeconds <= outSeconds){
                      alert('Recording should be longer than final video length or you\'re doing it wrong.');
                      return false;
                  }
  
                  //console.log({shotsperday, shotsperhour, shotspermin, shotspersec, shotspermsec})
  
                  if(shotsperday <= 1){
                      var value = Math.round((1/shotsperday)*100)/100;
                      var unit = 'day';
                  }
                  else if(shotsperhour <= 1){
                      var value = Math.round((1/shotsperhour)*100)/100;
                      var unit = 'hour';
                  }
                  else if(shotspermin <= 1){
                      var value = Math.round((1/shotspermin)*100)/100;
                      var unit = 'minute';
                  }
                  else if(shotspersec <= 1){//  
                      // shot every x seconds
                      var value = Math.round((1/shotspersec)*100)/100;
                      var unit = 'second';
                  }
                  else {//  if(shotspermsec <= 1)
                      // shot every x seconds
                      //var value = Math.round((1/shotspermsec)*100)/100;
                      //var unit = 'millisecond';
                      var value = Math.round((1/shotspermsec)*100)/100;
                      var unit = 'millisecond';
                  }
  
                  //$('.calc-area-shutint .result-every').html('One shot every ' + '<span>' + value + ' ' + unit + plural(value) + '</span>');
                  var line1 = 'One shot every ' + '<span>' + value + ' ' + unit + plural(value) + '</span>';
  
  
                  if(shotspersec >= 1){
                      var value = Math.round(shotspersec*100)/100;
                      var units = 'second';
                      
                  }else if(shotspermin >= 1){
                      var value = Math.round(shotspermin*100)/100;
                      var units = 'minute';
                  
                  }else if(shotsperhour >= 1){
                      var value = Math.round(shotsperhour*100)/100;
                      var units = 'hour';
                      
                  }else{
                      var value = Math.round(shotsperhour*100)/100;
                      var units = 'day';
                      
                  }
  
                  var line2 = `<span>${value} shot${plural(value)}</span> per ${units}`;
                  
                  $('.result-area .result-pre').html(`Your shutter interval should be...`);
                  $('.result-area .result').html(`<strong>${line1}</strong> or <strong>${line2}</strong>`);
                  break;
              case 1:
                  var intSeconds = $('.calc-area-rectime .int option:selected').val();
                  if($('.calc-area-rectime .intunits option:selected').val() == 'm')intSeconds /= 60;
                  if($('.calc-area-rectime .intunits option:selected').val() == 'h')intSeconds /= 3600;
                  if($('.calc-area-rectime .intunits option:selected').val() == 'd')intSeconds /= 86400;
      
                  var outSeconds = $('.calc-area-rectime .outtime option:selected').val();
                  if($('.calc-area-rectime .outunits option:selected').val() == 'm')outSeconds *= 60;
                  if($('.calc-area-rectime .outunits option:selected').val() == 'h')outSeconds *= 3600;
                  if($('.calc-area-rectime .outunits option:selected').val() == 'd')outSeconds *= 86400;
      
                  var fps = $('.calc-area-rectime .fps option:selected').val();
  
                  
  
                  //var recSeconds = fps * (1/intSeconds) * outSeconds;
                  var recSeconds = fps * outSeconds / (intSeconds)
  
  
  
                  var recMinutes = recSeconds / 60;
                  var recHours = recMinutes / 60;
                  var recDays = recHours / 24;
      
                  if(intSeconds >= fps * outSeconds){
                      alert('Shutter interval should be slower than final video length or you\'re doing it wrong.');
                      return false;
                  }
  
                  if(recDays >= 2){
                      var value = Math.round(recDays*100)/100;
                      var units = 'day';
                      
                  }else if(recHours >= 2){
                      var value = Math.round(recHours*100)/100;
                      var units = 'hour';
                     
                  }else if(recMinutes >= 2){
                      var value = Math.round(recMinutes*100)/100;
                      var units = 'minute';
                      
                  }else{
                      var value = Math.round(recSeconds*100)/100;
                      var units = 'second';
                  }
      
      
                  $('.result-area .result-pre').html(`You should record for...`);
                  $('.result-area .result').html(formatTimeString(recSeconds));
                  break;
  
              case 2:
                  var intSeconds = $('.calc-area-vidlen .int option:selected').val();
                  if($('.calc-area-vidlen .intunits option:selected').val() == 'm')intSeconds *= 60;
                  if($('.calc-area-vidlen .intunits option:selected').val() == 'h')intSeconds *= 3600;
                  if($('.calc-area-vidlen .intunits option:selected').val() == 'd')intSeconds *= 86400;
  
                  var recSeconds = $('.calc-area-vidlen .rectime option:selected').val();
                  if($('.calc-area-vidlen .recunits option:selected').val() == 'm')recSeconds *= 60;
                  if($('.calc-area-vidlen .recunits option:selected').val() == 'h')recSeconds *= 3600;
                  if($('.calc-area-vidlen .recunits option:selected').val() == 'd')recSeconds *= 86400;
  
                  var fps = $('.calc-area-vidlen .fps option:selected').val();
  
  
  
                  var outSeconds = intSeconds * recSeconds / fps;
                  var outMinutes = outSeconds / 60;
                  var outHours = outMinutes / 60;
                  var outDays = outHours / 24;
  
  
                  if(outDays >= 2){
                      var value = Math.round(outDays*100)/100;
                      var units = 'day';
                      
                  }else if(outHours >= 2){
                      var value = Math.round(outHours*100)/100;
                      var units = 'hour';
                  
                  }else if(outMinutes >= 2){
                      var value = Math.round(outMinutes*100)/100;
                      var units = 'minute';
                      
                  }else{
                      var value = Math.round(outSeconds*100)/100;
                      var units = 'second';
                  }
  
                  $('.result-area .result-pre').html(`Your video length will be...`);
                  $('.result-area .result').html(value  + ' ' + units + (value == 1?'':'s'));
                  
                  break;
              }
  
              $(this).addClass('disabled');
              $('.result-container').fadeIn();
          });
  
  
          
      });
  
  })(jQuery);
  
  
  function plural(val){
      if(val == 1)
          return '';
      else
          return 's';
  }
  
  function formatTimeString(seconds){
  
      var outString = "";
  
      
      var weeks = Math.round(seconds / 60 / 60 / 24 / 7);
      if(weeks >= 1){
          seconds -= weeks * 7 * 24 * 60 * 60 ;
          outString = outString.concat(weeks + " week" + plural(weeks) + " ");
      }
  
      var days = Math.round(seconds / 60 / 60 / 24);
      if(days >= 1){
          seconds -= days * 24 * 60 * 60 ;
          outString = outString.concat(days + " day" + plural(days) + " ");
      }
      var hours = Math.round(seconds / 60 / 60);
      if(hours >= 1){
          seconds -= hours * 60 * 60;
          outString = outString.concat(hours + " hour" + plural(hours) + " ")
      }
      var minutes = Math.round(seconds / 60);
      if(minutes >= 1){
          seconds -= minutes * 60;
          outString = outString.concat(minutes + " minute" + plural(minutes) + " ")
      }
      if(seconds > 0)outString = outString.concat(seconds + " second" + plural(seconds) + " ")
      //console.log("out: " + outString);
      return outString;
  
  
  }